export const environment = {
  production: true,
  environment: 'production',
  wsBaseUrl: 'https://ws.thesolutionsmovement.org',
  baseUrl: 'https://api.thesolutionsmovement.org',
  apiBaseUrl: 'https://api.thesolutionsmovement.org/api/v5',
  devUrl: 'https://app.thesolutionsmovement.org',
  host: 'thesolutionsmovement.org',
  imageBaseUrl: 'https://d36yzrhbooji3o.cloudfront.net/',
  theme: 'arkius',
  googleAuth: {
    // Public OAuth client IDs for the production web and native apps.
    webClientId:
      '1062011175001-95sepn03jfda5mkef6aeqqvuu53ur0ip.apps.googleusercontent.com',
    iOSClientId:
      '1062011175001-q8npknokcu00tb40n3ipj4r9019pjjgq.apps.googleusercontent.com',
  },
  appleAuth: {
    iOSClientId: 'com.thesolutionsmovement.app',
    webClientId: 'org.thesolutionsmovement.app.sid',
    redirectUrl: 'https://app.thesolutionsmovement.org/auth/apple/callback',
    // Enable Android in production after its backend callback is deployed.
    androidRedirectUrl: '',
  },
  log: (message?: any, ...optionalParams: any[]) => {},
};
